import { get } from 'vio-libs';
export function getLocations(consumerAPI = false) {
    if (!consumerAPI) {
        return get('locations');
    }
    return get('v1/edge-locations', undefined, true);
}
